export default __webpack_public_path__ + "static/media/pic4.61a71e73.png";